import { z } from 'zod';

export const pageSchema = z.object({
  title: z.string().min(3, { message: 'Title must be 3 or more characters long' }),
  details: z.string().optional(),
  privacy: z.string().optional(),
  tags: z.array(z.any()).optional(),
  users: z.array(z.any()).optional()
});
